
// Ne correspond pas aux ids des modes de jeu dans la base de données
export enum GameModes {
    UNDEFINED = 0,
    CLASSIC_SOLO = 1,
    RACE_SOLO = 2,
    FASTAILY = 3
}